// extracted by mini-css-extract-plugin
module.exports = {"job-content-link__summary":"job-content-link__summary","job-content-link__list":"job-content-link__list","job-content-link__item":"job-content-link__item"};